export const PACKAGE_URL_BASE_PATH = '/p/sets';
export const MAJOR_APPLIANCE_TYPE = 'MAJOR_APPLIANCE';
export const ITEM_PROMO = 'ITEMPROMO';
export const ORDER_PROMO = 'ORDERPROMO';

export const PRODUCT_POD = 'product pod';
export const KITCHEN_PACKAGE = 'kitchen package';
export const GM_PACKAGE = 'gen merch package';
export const VISUAL_PRODUCT_IMAGES_MAX_COUNT = 6;
